function offerCardsCarousel() {
	var owl5 = $(".index-offerCards .owlCarousel");
	owl5.owlCarousel({
		loop:false,
		responsive:{
			0:{items:1},
			640:{items:2},
			1024:{items:3},
			1800:{items:4},
		},
		autoplay: true,
		autoplayTimeout: 5000,
		autoplayHoverPause: true,
		loop: false
	});
	$(".index-offerCards .right").click(function() {
		owl5.trigger('next.owl.carousel');
	});
	$(".index-offerCards .left").click(function() {
		owl5.trigger("prev.owl.carousel");
	});
}